module.exports = __webpack_public_path__ + "static/media/19ESCAP34.f23a5e63.jpg";